<template>
  <div style="padding: 50px">
    <el-form ref="inforForm" :model="inforForm" label-position="left" size="small" label-width="72px">
      <el-form-item label="当前账号:" prop="phone">
        {{ inforForm.phone }}
      </el-form-item>
      <el-form-item prop="verifyCode" label="验证码:" size="small"
        :rules="[ { required: true, message: '请输入短信验证码', trigger: 'change', }, ]">
        <el-input v-model.trim="inforForm.verifyCode" placeholder="请输入短信验证码" style="width: 500px" size="small"
          auto-complete="off">
          <p v-if="!time" slot="suffix" style="cursor: pointer; color: #1e6ef5;margin-right:8px"
            @click="huoquyanzhengma">
            获取验证码
          </p>
          <p v-if="time" slot="suffix">
            {{ time }}秒后可重新获取
          </p>
        </el-input>
      </el-form-item>
    </el-form>
    <el-form ref="inforForm1" size="small" :model="inforForm1" label-position="left" label-width="72px">
      <el-form-item label="更换为:" prop="phone" size="small"
        :rules="[ { required: true, validator: this.validatephone, trigger: 'change', }, ]">
        <el-input v-model.trim="inforForm1.phone" size="small" style="width: 500px" placeholder="请输入新的手机号" clearable
          @input="ddd"></el-input>
      </el-form-item>
      <el-form-item prop="verifyCode" label="验证码:" size="small"
        :rules="[ { required: true, message: '请输入短信验证码', trigger: 'change', }, ]">
        <el-input v-model.trim="inforForm1.verifyCode" placeholder="请输入短信验证码" style="width: 500px" size="small">
          <p v-if="!time1" slot="suffix" style="cursor: pointer; color: #1e6ef5;margin-right:8px"
            @click="huoquyanzhengma1">
            获取验证码
          </p>
          <p v-if="time1" slot="suffix">
            {{ time1 }}秒后可重新获取
          </p>
        </el-input>
      </el-form-item>
    </el-form>
    <el-button type="primary" size="small" @click="updateBtn">
      保存
    </el-button>
  </div>
</template>

<script>
import { mapState } from "vuex";
import registerService from "@/CommonDP/service/register-service";
import request from "@/CommonDP/service/userCenter-service";
import requeslogout from "@/CommonDP/service/login-service";
export default {
  name: "ModifyPhone",
  data() {
    return {
      inforForm: {
        phone: "",
        verifyCode: ""
      },
      inforForm1: {
        phone: "",
        verifyCode: ""
      },
      time: "",
      time1: "",
      dd: ""
    };
  },
  computed: {
    ...mapState({
      username: (state) => state.user.username
    })
  },
  created() {
    this.inforForm.phone = this.username;
  },
  methods: {
    huoquyanzhengma() {
      var params = {
        phone: this.inforForm.phone,
        smsTemplateId: "1135606"
      };
      registerService.smssendVerifyCode(params).then((res) => {
        if (res.result == "0") {
          this.time = 60;
          this.flushTime();
        }
      });
    },
    flushTime() {
      const that = this;
      const intval = setInterval(function () {
        that.time--;
        if (that.time < 1) {
          that.time = 0;
          clearInterval(intval);
        }
      }, 1000);
    },
    huoquyanzhengma1() {
      this.$refs.inforForm1.validateField("phone");
      if (this.repeat2) {
        var encoded = encodeURI(this.repeat2);
        var params = { phone: encoded };
        registerService.userexists(params).then((res) => {
          if (res.data != 0) {
            this.dd = true;
            this.$refs.inforForm1.validateField("phone");
          } else {
            this.dd = false;
            this.$refs.inforForm1.validateField("phone");
            // 开始发起验证码
            var params = {
              phone: this.inforForm1.phone,
              smsTemplateId: "1135606"
            };
            registerService.smssendVerifyCode(params).then((res) => {
              if (res.result == "0") {
                this.time1 = 60;
                this.flushTime1();
              }
            });
          }
        });
      }
    },
    flushTime1() {
      const that = this;
      const intval = setInterval(function () {
        that.time1--;
        if (that.time1 < 1) {
          that.time1 = 0;
          clearInterval(intval);
        }
      }, 1000);
    },
    async updateBtn() {
      await this.$refs.inforForm.validate();
      await this.$refs.inforForm1.validate();
      const list = [];
      list[0] = this.inforForm;
      list[1] = this.inforForm1;
      const res = await request.updateUserPhone(list);
      if (res.result == "0") {
        requeslogout.logout();
        this.$router.replace("/");
        this.$message.info("修改成功,请重新登录");
      }
    },
    ddd() {
      this.dd = false;
    },
    validatephone(rule, value, callback) {
      var idCardx = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
      this.disabled = true;
      this.repeat1 = callback;
      this.repeat2 = value;
      this.repeat3 = rule;
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (this.inforForm1.phone.length > 11) {
        callback(new Error("手机号码不得超过11位"));
      } else if (!idCardx.test(value)) {
        callback(new Error("请输入正确的手机号码"));
      } else if (this.dd) {
        this.visible = false;
        callback(new Error("该手机号已注册"));
      } else {
        this.disabled = false;
        callback();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
